import type { H3Event } from 'h3';
import {
  CustomRequestContext,
  RouteCacheSSRContext,
  RuntimeExtraContext,
} from '../types/ssrContext';

export const ROUTE_CACHE_CONTEXT_KEY = '__ROUTE_CACHE_CONTEXT';
export const RUNTIME_CONTEXT_KEY = '__RUNTIME_CONTEXT';
export const CUSTOM_REQUEST_CONTEXT = '__CUSTOM_REQUEST_CONTEXT';
export const GLOBAL_SERVICES_CONTEXT = '__GLOBAL_SERVICES_CONTEXT';

export const getRouteCacheContext = (event: H3Event): RouteCacheSSRContext => {
  return event?.context?.[ROUTE_CACHE_CONTEXT_KEY];
};

export const getRuntimeContext = (event: H3Event): RuntimeExtraContext => {
  return event?.context?.[RUNTIME_CONTEXT_KEY];
};

export const getCustomRequestContext = (event: H3Event): CustomRequestContext => {
  return event?.context?.[CUSTOM_REQUEST_CONTEXT];
};
